import * as yup from 'yup';

const validationText = {
  min: {
    en: 'Cannot be negative',
    es: 'No puede ser negativo',
    qu: 'TRANSLATE',
  },
  max: {
    en: 'Cannot exceed 100',
    es: 'No puede exceder 100',
    qu: 'TRANSLATE',
  },
  positive: {
    en: 'Must be positive',
    es: 'Debe ser positivo',
    qu: 'Positivo kanan',
  },
  required: {
    en: 'Required field',
    es: 'Obligatorio',
    qu: 'Ruwana kan',
  },
  oneCrop: {
    en: 'Must select at least one crop',
    es: 'Debe seleccionar al menos un cultivo',
    qu: 'Juk mikhunallatapas akllay',
  },
  unit: {
    en: 'Must select a unit',
    es: 'Debe seleccionar una unidad',
    qu: 'Jukllaptapas akllana kan',
  },
};

export default function getSchema(lang) {
  const schema = yup.object().shape({
    crops: yup.array().of(
      yup.object().shape({
        name: yup.string().required(),
        bound: yup
          .number()
          .typeError(validationText.positive[lang])
          .min(0, validationText.min[lang])
          .max(100, validationText.max[lang])
          .required(validationText.required[lang]),
        costToPlant: yup
          .number()
          .typeError(validationText.positive[lang])
          .positive(validationText.positive[lang])
          .required(validationText.required[lang]),
        marketPrice: yup
          .number()
          .typeError(validationText.positive[lang])
          .positive(validationText.positive[lang])
          .required(validationText.required[lang]),
        plantDistribution: yup
          .number()
          .typeError(validationText.positive[lang])
          .min(0, validationText.min[lang])
          .max(100, validationText.max[lang])
          .required(validationText.required[lang]),
        typicalYield: yup
          .number()
          .typeError(validationText.positive[lang])
          .positive(validationText.positive[lang])
          .required(validationText.required[lang]),
      })
    ),
    // .required(validationText.oneCrop[lang]),
    landAvailable: yup
      .number()
      .typeError(validationText.positive[lang])
      .positive(validationText.positive[lang])
      .required(validationText.required[lang]),
    landAvailableUnit: yup.string().required(validationText.unit[lang]),
    soilCode: yup
      .number()
      .typeError(validationText.positive[lang])
      .positive(validationText.positive[lang])
      .required(validationText.required[lang]),
    waterAccessFlowRate: yup
      .number()
      .typeError(validationText.positive[lang])
      .positive(validationText.positive[lang])
      .required(validationText.required[lang]),
    waterAccessHours: yup
      .number()
      .typeError(validationText.positive[lang])
      .positive(validationText.positive[lang])
      .required(validationText.required[lang]),
    waterAccessMonths: yup
      .number()
      .typeError(validationText.positive[lang])
      .positive(validationText.positive[lang])
      .required(validationText.required[lang]),
  });

  return schema;
}
